import { BCMSDefaultModel, BCMSRecord, useGlobalController, useModel, useParams, Workflow } from "@bcm-dev/bcms-vite";
import PaymentInquiryConfirmationPage from "compid/pages/PaymentInquiryConfirmationPage";
import PaymentInquiryPage from "compid/pages/PaymentInquiryPage";
import { Account, Email, Payment, PaymentInquiry, Profile } from "model";
import React from "react";

// Steps of the workflow
const steps = {
    "/paymentInquiry" : <PaymentInquiryPage/>,
    "/paymentInquiryConfirmation" : <PaymentInquiryConfirmationPage/>
};

/**
 * @function PaymentInquiryWorkflow
 * @returns {React.Component}
 * @description The main component for the payment inquiry workflow
 */
export default function PaymentInquiryWorkflow(props) {
    // Initalize a global controller instance
    const controller = useGlobalController();
    // Grab the paymentID from the parameters
    const { paymentID } = useParams();
    // Access model.
    const model = useModel();
    // Get the default value for the workflow
    const value = getDefault(controller, paymentID, model);
    return <Workflow value={ value } steps={ Object.values(steps) } />
}

/**
 * @function getWorkflowSteps
 * @returns {OBJECT}
 * @description Hook to get the steps of the reminder workflow
 */
export const getWorkflowSteps = () => steps;

/**
 * @function getDefault
 * @param {BCMSGlobalController} controller - Global controller instance
 * @param {STRING} paymentID - The paymentID passed through the parameter
 * @returns {OBJECT}
 * @description Function to create the default value of the payment inquiry workflow.
 */
export const getDefault = (controller, paymentID, model) => {
    BCMSRecord.globalControllerFor([ Account, Payment, PaymentInquiry, Email, Profile ], controller);
    const payment = paymentID === undefined ? Payment.firstInstanceOf() : Payment.initByID(paymentID);
    const paymentInquiry = BCMSDefaultModel.paymentInquiry();
    paymentInquiry.id = PaymentInquiry.nextID();
    paymentInquiry.phoneNumber = "";
    paymentInquiry.payment = payment;
    paymentInquiry.payFromAccount = payment.from;
    paymentInquiry.reason = "";
    paymentInquiry.additionalComments = "";
    paymentInquiry.contactName = "";
    
    return {
        paymentInquiry: paymentInquiry,
        userSetLateFeesAccessed: false,
        userSetLateFeesAmount: false,
        userSetFinanceChargesAssessed: false,
        userSetFinanceChargesAmount: false,
        userSetContactDate: false
    }
};